import { render, staticRenderFns } from "./LegalFormFilter.vue?vue&type=template&id=5303224f&scoped=true"
import script from "./LegalFormFilter.vue?vue&type=script&lang=js"
export * from "./LegalFormFilter.vue?vue&type=script&lang=js"
import style0 from "./LegalFormFilter.vue?vue&type=style&index=0&id=5303224f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5303224f",
  null
  
)

export default component.exports